import {
  Grid,
  Typography,
  Stack,
  Button,
  IconButton,
  Box,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Autocomplete,
  FormControl,
  Tooltip,
  TextField,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  InputLabel,
  MenuItem,
  Select
} from '@mui/material';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import AddIcon from '@mui/icons-material/Add';
import '../StudyLogs.scss';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import React, { useEffect, useState } from 'react';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { useGetAssigneesMutation } from 'src/services/Utils';
import { setMessage } from 'src/store/Message';
import { useUser } from 'src/components/hooks/useUser';
import { useSqFollowupLetter } from './useSqFollowupLetter';
import moment from 'moment';
import CloseIcon from '@mui/icons-material/Close';
import { hideLoader, showLoader } from 'src/store/Loader';
import printPdfWithViewer from 'src/components/common/PrintPdfWithViewer';
import { useIssueLog } from '../IssueLog/useIssueLog';
import { SERVER_DATE_FORMAT, UI_TIME_ZONE } from 'src/constants/formats';
import { useMonitoringVisitLog } from '../MonitoringVisitLogs/useMonitoringVisitLog';
import { useSelectedAppInfo } from 'src/util/SelectedAppInfo';
import { PopupComponent } from 'src/components/common/PopupComponent';
import { setConfirmExitValue } from 'src/store/confirmExitValue';
import { archLevel } from 'src/data/config';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import SendIcon from '@mui/icons-material/Send';
import { EmailActivity } from '../EmailActivity';
import { useLazyGetEtmfDocDetailsByTmfDocumentIdQuery } from 'src/services/etmfDocLevel';
import ESignConsentReAuth from 'src/components/common/ESignConsentReAuth';
import { useFieldTranslation } from 'src/components/fields/useFieldTranslation';
import { useLazySetESignQuery } from 'src/services/ESignAPI';
import { useValidUserForReAuth } from 'src/components/hooks/useValidUserForReAuth';
import Loader from 'src/components/common/Loader';
import { MainRTE } from '@pihealth/common-ui-library';
import StaticJson from '../../../../resources/static.json';

const SiteQualitficationFollowupLetter: React.FunctionComponent<any> = ({
  siteStudyData,
  setSqFollowupLetterOpen,
  setStudyLogOpen,
  setNTFGrid,
  setOpenSQFollowLetter,
  selectedRow
}) => {
  const { isValidUserForReAuth } = useValidUserForReAuth();
  const [openSignConsent, setOpenSignConsent] = useState(false);
  const [approverDetails, setApproverDetails] = useState({
    id: '',
    approver_function: '',
    approver_comment: '',
    monitoring_visit_id: ''
  });
  const { applicationModuleSection, unSavedWarning } = useFieldTranslation();
  const { getPreferredDateInLocal, getPreferredDateTimeInLocal, userPreferedDateFormat, preferedFormatForDatePicker } =
    usePreferedDateFormat();
  const { checkPermission } = usePermissionWrapper();
  const updateSQFLPermission = checkPermission('update_sq_followupletter');
  const approveSQFLPermission = checkPermission('approve_sq_followupletter');
  const publishSQFLPermission = checkPermission('publish_sq_followupletter');
  const editSQFLPermission = checkPermission('edit_sq_followup_letter');
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const sponsor = useAppSelector(state => state.user.user?.sponsor);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const email = useAppSelector(state => state.user.user?.email);
  const role = useAppSelector(state => state.site?.userAccessData.site.resData[0]?.role);
  const [salutation, setSalutation] = useState<string>('');
  const [dataFields, setDataFields] = useState<any>([]);
  const [salulationErr, setSalulationErr] = useState(false);
  const [isVersion, setIsVersion] = useState(false);
  const [filteredIssues, setFilteredIssues] = useState([]);
  const [addDisable, setDisable] = useState(false);
  const [isChange, setIsChange] = useState(false);
  const { getIssueLogBasedOnDateRange } = useIssueLog();
  const { selectedAppSection } = useSelectedAppInfo();
  const [openConfirmExit, setOpenConfirmExit] = useState(false);
  const [checkedInStartDate, setCheckedInStartDate] = useState<any>(null);
  const [checkInDateTime, setCheckInDateTime] = useState<any>(null);
  const [openImport, setOpenImport] = useState(false);
  const [openEmailPopoup, setOpenEmailPopoup] = useState(false);
  const [openRTE, setOpenRTE] = useState(false);
  const [openRTEContent, setOpenRTEContent] = useState(false);
  const [htmlContent, setHtmlContent] = useState('');
  const [disableEditContent, setDisableEditContent] = useState(false);
  const [openVersionPopup, setOpenVersionPopup] = useState(false);

  const [importFields, setImportFields] = useState({
    sq_visit_issue: '',
    sq_visit_start_date: '',
    sq_visit_end_date: ''
  });
  const [importFieldError, setImportFieldError] = useState<any>({
    sq_visit_start_date: null,
    sq_visit_end_date: null
  });
  const dateFormat = userPreferedDateFormat.toUpperCase();
  const approveSignaturePermission = `APPROVE_SITEQUALIFI_FOLLOWUPLETTER`;
  const staticData = {
    approver_function: null,
    approver_comment: null,
    approved_by: null,
    approver_role: null,
    approver_email: null,
    isNew: true
  };
  const {
    selectSqFollowupLetter,
    selectSqFollowupLetterData,
    selectSqFollowupLetterIsError,
    updateSqFollowupLetter,
    updateSqFollowupLetterIsLoading,
    updateSqFollowupLetterIsError,
    updateSqFollowupLetterError,
    updateSqFollowupLetterIsSuccess,
    signSqFollowupLetterIsError,
    signSqFollowupLetterError,
    publishSqFollowupLetter,
    publishSqFollowupLetterIsLoading,
    publishSqFollowupLetterIsError,
    publishSqFollowupLetterError,
    publishSqFollowupLetterIsSuccess,
    createNewVersion,
    createNewVersionIsSuccess
  } = useSqFollowupLetter();
  const { getAllMonitoringVisits } = useMonitoringVisitLog();
  const dispatch = useAppDispatch();
  const [userList, setUserList] = useState<any[]>([]);
  const { user } = useUser();
  const [
    getUser,
    { data: userData, isError: userDataIsError, isSuccess: userDataIsSuccess, isLoading: userDataIsLoading }
  ] = useGetAssigneesMutation();

  const [getDocumentOnTmfDocumentId, { data: documentOnTmfDocumentIdData }] =
    useLazyGetEtmfDocDetailsByTmfDocumentIdQuery();

  const isUpdatePublish = selectSqFollowupLetterData?.visit_follow_up?.publish_version_etmf ? true : false;

  const handelBack = () => {
    if (isChange) {
      setOpenConfirmExit(true);
    } else {
      setSqFollowupLetterOpen(true);
      setStudyLogOpen(false);
      setOpenSQFollowLetter(false);
      setIsChange(false);
      setNTFGrid(true);
      setConfirmExitValue(dispatch, false);
    }
  };
  const handleSalutaion = (value: any) => {
    setSalutation(value.trimStart());
    setSalulationErr(false);
    setIsChange(true);
    setConfirmExitValue(dispatch, true);
  };

  const handleAdd = () => {
    setDataFields([...dataFields, { ...staticData, id: dataFields.length }]);
    setIsChange(true);
    setConfirmExitValue(dispatch, true);
  };

  const handleChangeSingle = (_: any, values: any, id?: any) => {
    setDataFields(
      dataFields.map((ele: any) => {
        if (ele.id === id) {
          return { ...ele, approver_function: values };
        } else {
          return ele;
        }
      })
    );
    setIsChange(true);
    setConfirmExitValue(dispatch, true);
  };

  const handleComment = (e: any, id?: any) => {
    const value = e.target.value;
    const commentAdded = dataFields.map((ele: any) => {
      if (ele.id === id) {
        return { ...ele, approver_comment: value };
      } else {
        return ele;
      }
    });
    setDataFields(commentAdded);
    setIsChange(true);
    setConfirmExitValue(dispatch, true);
  };

  const handleClose = (row: any) => {
    const filtered = dataFields.filter((ele: any) => ele.id !== row.id);
    setDataFields(filtered);
    setConfirmExitValue(dispatch, true);
  };

  const getSqFollowupLetterData = async () => {
    dispatch(showLoader());
    await selectSqFollowupLetter({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      visit_follow_up_id: selectedRow?.id
    });
  };

  const getMonitoringVisitList = async (
    studyId: string | null,
    selectedCountry: string | null,
    selectedSite: string | null,
    currentApp: string
  ) => {
    const allMonitoringResponse: any = await getAllMonitoringVisits({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      application_section: currentApp,
      data: {}
    });
    if (allMonitoringResponse?.data && allMonitoringResponse?.data.selected_data.length > 0) {
      const sqCheckedInDate: any = allMonitoringResponse.data.selected_data.filter(
        (visit: any) => visit.visit_type === 'Site Qualification Visit'
      );
      if (sqCheckedInDate.length && sqCheckedInDate[0].actual_start_date) {
        setCheckedInStartDate(
          moment(`${sqCheckedInDate[0].actual_start_date.replace(' ', 'T')}Z`).format(
            userPreferedDateFormat.toUpperCase()
          )
        );
        setCheckInDateTime(sqCheckedInDate[0].actual_start_date);
      } else {
        setCheckedInStartDate(null);
      }
    } else {
      setCheckedInStartDate(null);
    }
  };

  const dateTime = getPreferredDateTimeInLocal(
    checkedInStartDate ? getPreferredDateTimeInLocal(checkInDateTime) : selectedRow?.start_date
  )?.split(' ');

  let date;
  let time;
  let meridiem;
  if (dateTime) {
    date = dateTime[0];
    time = dateTime[1];
    meridiem = dateTime[2];
  }

  const validationOfRTE =
    selectSqFollowupLetterData?.visit_follow_up?.sqfl_rte1 === '' ||
    selectSqFollowupLetterData?.visit_follow_up?.sqfl_rte1 === null
      ? StaticJson.SQFollowupLetterRTE
      : selectSqFollowupLetterData?.visit_follow_up?.sqfl_rte1;

  const handleSaveSQFL = async () => {
    const newUserData = dataFields.filter((ele: any) => ele.isNew && ele.approver_function !== null);
    if (salutation) {
      const payload = {
        monitoring_visit_id: selectedRow?.id,
        visit_follow_up: {
          visit_scheduled_date: new Date(
            checkedInStartDate ? moment.utc(checkedInStartDate).format() : selectedRow?.start_date
          ),
          salutation_letter: salutation.trim(),
          sq_follow_up_sponsor_name: sponsor?.toUpperCase(),
          sq_follow_up_publish_version: 0,
          tp_document_meta_id: selectedRow?.id,
          tp_document_id: 'string',
          is_published_etmf: false,
          sq_visit_issue: importFields?.sq_visit_issue,
          sq_visit_start_date: importFields?.sq_visit_start_date,
          sq_visit_end_date: importFields?.sq_visit_end_date,
          sqfl_rte1: htmlContent === '' ? validationOfRTE : htmlContent
        },
        issues: filteredIssues,
        sq_follow_up_comments: newUserData,
        updated_by: user
      };
      updateSqFollowupLetter({
        site_id: selectedSite,
        study_id: studyId,
        country: selectedCountry,
        data: payload
      });
    } else {
      setSalulationErr(true);
    }
    setConfirmExitValue(dispatch, false);
  };

  const handleSignApproval = async (row: any) => {
    setOpenSignConsent(true);
    setApproverDetails({
      ...approverDetails,
      id: row.id,
      monitoring_visit_id: row.monitoring_visit_id,
      approver_function: row.approver_function,
      approver_comment: row.approver_comment
    });
  };

  const printSQFL = async () => {
    try {
      dispatch(showLoader());
      const options = {
        sq_visit_id: selectedRow?.id,
        template_name: 'site_qualification_follow_up_letter',
        study_id: studyId,
        site_id: selectedSite,
        pathVariables: {
          country: selectedCountry,
          appName: `${archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP}`,
          time_zone_id: UI_TIME_ZONE
        }
      };
      printPdfWithViewer('get_sqFollowupletter_pdf_file', options, 'application/pdf');
      setTimeout(() => {
        dispatch(hideLoader());
      }, 1500);
    } catch (error: any) {
      dispatch(hideLoader());
      dispatch(setMessage({ msgDetails: 'Error while fetching pdf', severity: 'error' }));
    }
    setConfirmExitValue(dispatch, false);
  };

  const approvedBy = selectSqFollowupLetterData?.sq_follow_up_comments?.length
    ? selectSqFollowupLetterData?.sq_follow_up_comments
        ?.map((elem: any) => elem.approved_by)
        .some((elem: any) => elem === null)
    : true;

  const handlePublishSQFL = async () => {
    if (publishSQFLPermission) {
      try {
        dispatch(showLoader());
        await publishSqFollowupLetter({
          site_id: selectedSite,
          study_id: studyId,
          country: selectedCountry,
          sq_visit_id: selectedRow?.id,
          time_zone_id: UI_TIME_ZONE,
          publish_doc_version:
            selectSqFollowupLetterData?.visit_follow_up?.publish_version_etmf >= 1
              ? Math.floor(selectSqFollowupLetterData?.visit_follow_up?.publish_version_etmf + 1)
              : '1.0',
          is_published_etmf: true,
          update: isUpdatePublish
        });
        dispatch(hideLoader());
        await getSqFollowupLetterData();
      } catch (error: any) {
        dispatch(hideLoader());
        if (error && error?.response?.status === 403) {
          dispatch(setMessage({ msgDetails: 'Error 403 Restricted User permission', severity: 'error' }));
        } else if (error && error.response?.status === 401) {
          dispatch(setMessage({ msgDetails: 'Error 401 Unauthorized access', severity: 'error' }));
        } else {
          dispatch(setMessage({ msgDetails: 'Error while publishing', severity: 'error' }));
        }
      }
    }
    setConfirmExitValue(dispatch, false);
  };

  const handleChange = (e: any) => {
    setImportFields({ ...importFields, sq_visit_issue: selectedRow?.visit_name });
    setSalulationErr(false);
    setIsChange(true);
    setConfirmExitValue(dispatch, true);
  };

  const handleClickOpenImport = () => {
    setOpenImport(true);
    setImportFields({ ...importFields, sq_visit_issue: selectedRow?.visit_name });
    setConfirmExitValue(dispatch, true);
  };

  const handleCloseImport = () => {
    setOpenImport(false);
    setImportFieldError({ sq_visit_start_date: null, sq_visit_end_date: null });
  };

  const getServerDateOrInvalid = (newDateValue: any) => {
    return String(newDateValue.$d) !== 'Invalid Date'
      ? moment(newDateValue.$d).format(SERVER_DATE_FORMAT)
      : String(newDateValue.$d);
  };

  const handleImportSubmit = async () => {
    setIsChange(true);
    if (
      importFields?.sq_visit_start_date !== 'Invalid Date' &&
      importFields?.sq_visit_end_date !== 'Invalid Date' &&
      ((!!importFieldError?.sq_visit_start_date && !!importFieldError?.sq_visit_end_date) ||
        (importFields?.sq_visit_start_date != null && importFields?.sq_visit_end_date != null))
    ) {
      const filteredIssues: any = await getIssueLogBasedOnDateRange({
        site_id: selectedSite,
        study_id: studyId,
        country: selectedCountry,
        issue_level: 'SPONSOR',
        application: archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP,
        start_date: importFields?.sq_visit_start_date,
        end_date: importFields?.sq_visit_end_date
      });
      if (
        filteredIssues?.isSuccess &&
        filteredIssues?.data?.selected_data &&
        filteredIssues?.data?.selected_data.length > 0
      ) {
        const modifiedIssues: any = filteredIssues?.data?.selected_data.map((ele: any) => {
          return {
            id: ele.issue_details?.id,
            stdy_sqv_subject_id: ele.issue_details?.subject_id,
            stdy_sqv_issue_class: ele.issue_details?.issue_class,
            stdy_sqv_issues: ele.issue_details?.issue,
            stdy_sqv_category: ele.issue_details?.category,
            stdy_sqv_action_description: ele.issue_details?.action_des,
            stdy_sqv_action_due_date: ele.issue_details?.action_due
          };
        });
        setFilteredIssues(modifiedIssues);
        setConfirmExitValue(dispatch, true);
      } else {
        setFilteredIssues([]);
        setConfirmExitValue(dispatch, true);
        dispatch(setMessage({ msgDetails: 'No Issues', severity: 'error' }));
      }
      setOpenImport(false);
    } else {
      let sqErrorModified = { ...importFieldError };
      if (
        importFields?.sq_visit_start_date == null ||
        importFields?.sq_visit_start_date === 'Invalid Date' ||
        ((importFieldError?.sq_visit_start_date == false || importFieldError?.sq_visit_end_date == null) &&
          importFields?.sq_visit_start_date == null &&
          importFields?.sq_visit_start_date == 'Invalid Date')
      ) {
        sqErrorModified = { ...sqErrorModified, sq_visit_start_date: true };
      }
      if (
        importFields?.sq_visit_end_date == null ||
        importFields?.sq_visit_end_date === 'Invalid Date' ||
        ((importFieldError?.sq_visit_end_date == false || importFieldError?.sq_visit_end_date == null) &&
          importFields?.sq_visit_end_date == null &&
          importFields?.sq_visit_end_date == 'Invalid Date')
      ) {
        sqErrorModified = { ...sqErrorModified, sq_visit_end_date: true };
      }
      setImportFieldError({ ...importFieldError, ...sqErrorModified });
      dispatch(setMessage({ msgDetails: 'Mandatory information is missing', severity: 'error' }));
    }
  };

  const handleEmailActivity = () => {
    setOpenEmailPopoup(true);
  };

  useEffect(() => {
    if (!userDataIsLoading && userDataIsError) {
      dispatch(setMessage({ msgDetails: 'Unable to get the users', severity: 'error' }));
    } else if (userData && userDataIsSuccess && !userDataIsLoading) {
      const assignList: any = [];
      userData.map((item: any) =>
        assignList.push({
          key: `${item.first_name} ${item.last_name}`,
          displayName: `${item.first_name} ${item.last_name}`
        })
      );
      setUserList(assignList);
    }
  }, [userData, userDataIsLoading, userDataIsError]);

  const usersList: any = [];
  userList.filter(data => {
    const isDuplicate = usersList.includes(data.displayName);
    if (!isDuplicate) {
      usersList.push(data.displayName);
      return true;
    }
    return false;
  });

  useEffect(() => {
    getMonitoringVisitList(studyId, selectedCountry, selectedSite, selectedAppSection);
    getUser({
      client_name: 'ctms-ui',
      data: [approveSignaturePermission]
    });
    getSqFollowupLetterData();
  }, [studyId]);

  useEffect(() => {
    if (selectSqFollowupLetterData) {
      const issueData = selectSqFollowupLetterData.issues.map((elem: any) => {
        return {
          id: elem.id,
          stdy_sqv_subject_id: elem.stdy_sqv_subject_id,
          stdy_sqv_category: elem.stdy_sqv_category,
          stdy_sqv_issue_class: elem.stdy_sqv_issue_class,
          stdy_sqv_issues: elem.stdy_sqv_issues,
          stdy_sqv_action_description: elem.stdy_sqv_action_description,
          stdy_sqv_action_due_date: elem.stdy_sqv_action_due_date
        };
      });
      setFilteredIssues(issueData);
      const tempData: any = selectSqFollowupLetterData?.sq_follow_up_comments?.map((elem: any) => {
        if (elem.approver_comment === null) {
          return {
            approver_function: elem.approver_function,
            approver_comment: elem.approver_comment,
            approved_by: elem.approved_by,
            approver_role: elem.approver_role,
            approver_email: elem.approver_email,
            approved_datetime: elem.approved_datetime,
            id: elem.id,
            monitoring_visit_id: elem.monitoring_visit_id,
            reason: elem.reason,
            needtoupdate: true
          };
        } else {
          return {
            approver_function: elem.approver_function,
            approver_comment: elem.approver_comment,
            approved_by: elem.approved_by,
            approver_role: elem.approver_role,
            approver_email: elem.approver_email,
            approved_datetime: elem.approved_datetime,
            id: elem.id,
            monitoring_visit_id: elem.monitoring_visit_id,
            reason: elem.reason
          };
        }
      });
      setImportFields({
        sq_visit_issue: selectSqFollowupLetterData.visit_follow_up.sq_visit_issue,
        sq_visit_start_date: selectSqFollowupLetterData.visit_follow_up.sq_visit_start_date,
        sq_visit_end_date: selectSqFollowupLetterData.visit_follow_up.sq_visit_end_date
      });
      if (tempData.length) {
        setDisable(true);
      }
      setDataFields(tempData);
      setSalutation(selectSqFollowupLetterData?.visit_follow_up?.salutation_letter);
    }
    dispatch(hideLoader());
  }, [selectSqFollowupLetterData]);

  useEffect(() => {
    if (selectSqFollowupLetterData?.visit_follow_up?.is_published_etmf) {
      setIsVersion(true);
    } else {
      setIsVersion(false);
    }
  }, [selectSqFollowupLetterData]);

  useEffect(() => {
    if (updateSqFollowupLetterIsError || signSqFollowupLetterIsError || publishSqFollowupLetterIsError) {
      const err: any = updateSqFollowupLetterError || signSqFollowupLetterError || publishSqFollowupLetterError;
      if (err?.status == 500) {
        dispatch(
          setMessage({
            msgDetails: `${err?.status} : Internal Server Error`,
            severity: 'error'
          })
        );
      } else if (err?.status == 403) {
        dispatch(
          setMessage({
            msgDetails: 'Error 403 Restricted User permission',
            severity: 'error'
          })
        );
      } else if (err?.status == 404) {
        dispatch(
          setMessage({
            msgDetails: 'Error',
            severity: 'error'
          })
        );
      }
    }
    dispatch(hideLoader());
  }, [
    selectSqFollowupLetterIsError,
    updateSqFollowupLetterIsError,
    signSqFollowupLetterIsError,
    publishSqFollowupLetterIsError
  ]);

  useEffect(() => {
    if (publishSqFollowupLetterIsSuccess && !publishSqFollowupLetterIsLoading) {
      dispatch(
        setMessage({
          msgDetails: 'Successfully published to eTMF',
          severity: 'success'
        })
      );
    }
  }, [publishSqFollowupLetterIsSuccess, publishSqFollowupLetterIsLoading]);

  useEffect(() => {
    if (updateSqFollowupLetterIsSuccess && !updateSqFollowupLetterIsLoading) {
      dispatch(
        setMessage({
          msgDetails: 'Data updated successfully',
          severity: 'success'
        })
      );
      getSqFollowupLetterData();
      setOpenRTEContent(false);
      setDisableEditContent(false);
      setIsChange(false);
    }
  }, [updateSqFollowupLetterIsSuccess, updateSqFollowupLetterIsLoading]);

  useEffect(() => {
    if (createNewVersionIsSuccess) {
      dispatch(
        setMessage({
          msgDetails: 'New site qualification follow-up letter version ready to modify.',
          severity: 'success'
        })
      );
      setOpenVersionPopup(false);
      getSqFollowupLetterData();
      setOpenRTEContent(false);
      setDisableEditContent(false);
      setIsChange(false);
      setDisable(false);
    }
  }, [createNewVersionIsSuccess]);

  useEffect(() => {
    if (selectSqFollowupLetterData?.visit_follow_up?.tp_document_id_etmf) {
      getDocumentBasedTmfDocumentId(selectSqFollowupLetterData?.visit_follow_up?.tp_document_id_etmf);
    }
  }, [selectSqFollowupLetterData?.visit_follow_up?.tp_document_id_etmf]);

  const getDocumentBasedTmfDocumentId = async (tpDocumentId: string) => {
    await getDocumentOnTmfDocumentId({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      tmfDocumentId: tpDocumentId,
      application: archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP,
      module_section_related: applicationModuleSection.studyLogs,
      parent_entity_related: selectedRow?.visit_name
    });
  };
  const [setESignature] = useLazySetESignQuery();
  const handleSQApproverSign = async (data: any = {}) => {
    if (data.success) {
      if (!isValidUserForReAuth(data.records.user_name)) {
        dispatch(setMessage({ msgDetails: `Please e-sign with the logged in username`, severity: 'error' }));
      } else {
        setOpenSignConsent(false);
        dispatch(showLoader());
        const dataObj = {
          username: data.records.user_name,
          password: data.records.password,
          module_name: applicationModuleSection.sqFollowupLetter,
          name_of_signature: 'approved_by',
          name_of_date_field: 'approved_datetime',
          id: approverDetails.id,
          columns_to_change: {
            reason: data.records.sign_reason,
            approver_function: approverDetails.approver_function,
            approver_comment: approverDetails.approver_comment,
            approver_role: role,
            approver_email: email,
            updated_by: user
          },
          columns_to_filter: { monitoring_visit_id: approverDetails.monitoring_visit_id }
        };
        const signatureResponse: any = await setESignature({
          site_id: selectedSite,
          study_id: studyId,
          country: selectedCountry,
          application: process.env.REACT_APP_NAME,
          application_section: selectedAppSection,
          application_module_section: applicationModuleSection.studyLogs,
          data: dataObj
        });
        if (signatureResponse.isSuccess) {
          await getSqFollowupLetterData();
          setConfirmExitValue(dispatch, false);
          setIsChange(false);
          dispatch(
            setMessage({
              msgDetails: 'Approved Successfully',
              severity: 'success'
            })
          );
        } else if (signatureResponse.isError) {
          dispatch(setMessage({ msgDetails: `Authorization for ${data.records.user_name} failed`, severity: 'error' }));
        }
        setApproverDetails({
          id: '',
          approver_function: '',
          approver_comment: '',
          monitoring_visit_id: ''
        });
        dispatch(hideLoader());
      }
    }
  };
  const handleChangeTextEditor = (htmlContext: any, planetext: any, e: any) => {
    if (e === 'SQFollowupLetterRTE') {
      setHtmlContent(htmlContext);
    }
  };
  const handleEditRTE = (content: string) => {
    setOpenRTE(true);
    setOpenRTEContent(true);
  };
  const handleSaveRTE = (content: string) => {
    setOpenRTE(false);
    setDisableEditContent(true);
    setIsChange(true);
  };
  const approverName = selectSqFollowupLetterData?.sq_follow_up_comments?.filter((obj: any) => {
    return obj.approver_function === user;
  });
  const approverCondition = approverName?.length > 0 ? approverName[0].approver_function !== user : true;

  const handleCreateNewVersion = () => {
    setOpenVersionPopup(true);
  };

  useEffect(() => {
    if (
      selectSqFollowupLetterData?.sq_follow_up_comments &&
      Array.isArray(selectSqFollowupLetterData?.sq_follow_up_comments) &&
      selectSqFollowupLetterData?.sq_follow_up_comments?.length
    ) {
      setDisableEditContent(true);
    }
  }, [selectSqFollowupLetterData]);

  const handleCreateNewversion = () => {
    createNewVersion({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      application: archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP,
      sq_visit_id: selectedRow?.id,
      application_section: selectedAppSection
    });
  };

  return (
    <>
      <Loader />
      <Box className="mainBackBtnWrap">
        <Button onClick={handelBack} startIcon={<ArrowBackIcon fontSize="small" />}>
          SQ Follow-Up List
        </Button>
      </Box>
      <Grid container spacing={1} sx={{ mb: 1.5, alignItems: 'center' }}>
        <Grid item>
          <Typography variant="h5" component="h5" sx={{ margin: 0, fontSize: '20px', fontWeight: 500 }}>
            {selectedRow?.visit_name}
          </Typography>
        </Grid>
        <Grid item xs sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
          <Stack direction="row" spacing={1.5}>
            {archLevel === 'sponsor' && (
              <Button
                variant="contained"
                style={{ textTransform: 'none' }}
                sx={{ alignSelf: 'center' }}
                disabled={isVersion || !(publishSQFLPermission && !approvedBy)}
                onClick={() => handlePublishSQFL()}
              >
                PUBLISH TO eTMF
              </Button>
            )}

            {archLevel === 'sponsor' && (
              <Button
                sx={{ alignSelf: 'center' }}
                disabled={
                  !checkPermission('create_new_version_sq_confirmation_letter') ||
                  selectSqFollowupLetterData?.visit_follow_up?.is_published_etmf !== true
                }
                onClick={handleCreateNewVersion}
              >
                Create new version
              </Button>
            )}
            {archLevel === 'sponsor' && (
              <Button
                sx={{ alignSelf: 'center' }}
                onClick={() => handleSaveSQFL()}
                disabled={
                  (!updateSQFLPermission && !checkedInStartDate ? !checkedInStartDate : !selectedRow?.start_date) ||
                  !salutation ||
                  !isChange ||
                  isVersion
                    ? true
                    : (!approveSQFLPermission && checkedInStartDate ? !checkedInStartDate : !selectedRow?.start_date) ||
                      !salutation ||
                      !isChange
                    ? true
                    : false
                }
              >
                Save
              </Button>
            )}
            <IconButton
              aria-label="Print"
              color="primary"
              title="Print"
              sx={{ alignSelf: 'center' }}
              disabled={!selectSqFollowupLetterData?.visit_follow_up?.is_published_etmf}
              onClick={() => printSQFL()}
            >
              <LocalPrintshopIcon />
            </IconButton>
            {archLevel === 'sponsor' && (
              <IconButton
                aria-label="Send"
                color="primary"
                sx={{ alignSelf: 'center' }}
                onClick={() => handleEmailActivity()}
                disabled={
                  !checkPermission('email_sponsor_site_qualification_followup_letter') ||
                  !selectSqFollowupLetterData?.visit_follow_up?.is_published_etmf
                }
              >
                <SendIcon />
              </IconButton>
            )}
          </Stack>
        </Grid>
      </Grid>

      <Box className="letterPage">
        <Typography gutterBottom color="text.secondary2">
          {getPreferredDateInLocal(checkedInStartDate ? checkedInStartDate : selectedRow?.start_date)} <br />
          {siteStudyData?.pi_first_name} {siteStudyData?.pi_last_name} <br />
          {siteStudyData?.site_name} <br />
          {siteStudyData?.site_street_address1} {siteStudyData?.site_street_address2} <br />
          {siteStudyData?.site_city}, {siteStudyData?.site_state}, {siteStudyData?.site_zip_code}
        </Typography>
        <dl className="text-Bold dlStyle">
          <dt>RE:</dt>
          <dd>
            {siteStudyData?.study_id}-{siteStudyData?.study_title} <br />
            Site Qualification Follow-Up for Protocol {siteStudyData?.study_id} <br />
            Site Number: {siteStudyData?.site_id}
          </dd>
        </dl>
        <Typography sx={{ mb: 1, pt: 2 }}>
          Dear &nbsp;{' '}
          <span style={{ width: '220px', display: 'inline-block' }}>
            <TextField
              id="salutationField"
              label="Salutation"
              required
              inputProps={{ maxLength: 50 }}
              placeholder="Salutation"
              variant="standard"
              className="salutationField"
              value={salutation?.trimStart() ?? ''}
              onChange={(e: any) => handleSalutaion(e.target.value)}
              error={salulationErr}
              disabled={
                selectSqFollowupLetterData?.sq_follow_up_comments?.length > 0 || !updateSQFLPermission || isVersion
              }
              sx={{ mt: '-16px !important' }}
            />
          </span>
          {siteStudyData?.pi_first_name} {siteStudyData?.pi_last_name}
          , <br />
        </Typography>
        <Typography gutterBottom>
          I would like to thank you, and your team for your time during the Pre-Study Site Selection Visit for the
          above-mentioned study, which took place on {date} at {time} {meridiem} It was a pleasure to meet with you and
          your team. During our meeting the following items were discussed/reviewed:
        </Typography>
        {editSQFLPermission &&
        selectSqFollowupLetterData?.visit_follow_up?.is_published_etmf !== true &&
        approverCondition ? (
          <Paper variant="outlined" sx={{ position: 'relative', my: 2 }}>
            <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ py: 1.5, px: 2 }}>
              <Typography variant="subtitle1">Editable Content</Typography>
              {openRTE ? (
                <Button variant="contained" size="small" color="primary" onClick={() => handleSaveRTE('content')}>
                  SAVE
                </Button>
              ) : (
                <Button
                  variant="contained"
                  size="small"
                  color="primary"
                  disabled={disableEditContent}
                  onClick={() => handleEditRTE('content')}
                >
                  EDIT
                </Button>
              )}
            </Box>
            <Divider variant="middle" sx={{ mx: 0 }} />
            <Box className="editRTEBox" p={2}>
              {openRTEContent ? (
                <MainRTE
                  log={(htmlContext: any, planetext: any) =>
                    handleChangeTextEditor(htmlContext, planetext, 'SQFollowupLetterRTE')
                  }
                  value={validationOfRTE}
                  placeholder={'Enter Value'}
                  height={400}
                  disabled={disableEditContent}
                />
              ) : (
                <div
                  dangerouslySetInnerHTML={{
                    __html: validationOfRTE
                  }}
                />
              )}
            </Box>
          </Paper>
        ) : (
          <div
            dangerouslySetInnerHTML={{
              __html: validationOfRTE
            }}
          />
        )}
        <TableContainer sx={{ my: 2 }}>
          <Table aria-label="collapsible table" className="table table-bordered table-column-bordered">
            <TableHead>
              <TableRow>
                <TableCell sx={{ minWidth: 120 }}>
                  <b>Subject ID</b>
                </TableCell>
                <TableCell>
                  <b>Category</b>
                </TableCell>
                <TableCell sx={{ minWidth: 120 }}>
                  <b>Issue Class</b>
                </TableCell>
                <TableCell sx={{ minWidth: 120 }}>
                  <b>Issues</b>
                </TableCell>
                <TableCell>
                  <b>Action Description</b>
                </TableCell>
                <TableCell>
                  <b>Action due date</b>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredIssues.length ? (
                filteredIssues.map((row: any) => (
                  <TableRow key={row.id}>
                    <TableCell>{row.stdy_sqv_subject_id}</TableCell>
                    <TableCell>{row.stdy_sqv_category}</TableCell>
                    <TableCell>{row.stdy_sqv_issue_class}</TableCell>
                    <TableCell>{row.stdy_sqv_issues}</TableCell>
                    <TableCell>{row.stdy_sqv_action_description}</TableCell>
                    <TableCell>
                      {row.stdy_sqv_action_due_date !== null
                        ? moment(row.stdy_sqv_action_due_date).format(userPreferedDateFormat.toUpperCase())
                        : null}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow key={1}>
                  <TableCell colSpan={6}>No issues found</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <Button
          variant="contained"
          sx={{ mb: 2 }}
          onClick={handleClickOpenImport}
          disabled={
            selectSqFollowupLetterData?.sq_follow_up_comments?.length > 0 ||
            !updateSQFLPermission ||
            selectSqFollowupLetterData?.visit_follow_up?.is_published_etmf
          }
        >
          Import
        </Button>

        <Typography gutterBottom>
          A project team member will then be in touch with you in due course regarding the final decision on whether
          your site has been selected to participate in the study or not.
        </Typography>
        <Typography gutterBottom>
          Should you have any questions, please do not hesitate to contact me using the details below.
        </Typography>
        <Typography gutterBottom>
          Yours sincerely, <br />
          {user} <br />
          <span color="text.secondary">{sponsor?.toUpperCase()}</span>
        </Typography>
      </Box>

      <Box sx={{ pt: 2 }}>
        <Grid container>
          <Grid md={12}>
            <TableContainer
              className="studylog-table"
              sx={{ border: '1px solid rgba(0,0,0,0.12)', maxHeight: '280px' }}
            >
              <Table aria-label="collapsible table" className="table" stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell>Approver Function</TableCell>
                    <TableCell>Approver Comment</TableCell>
                    <TableCell>Approved by</TableCell>
                    <TableCell>Approved Date</TableCell>
                    <TableCell width={44} />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {dataFields.map((row: any, index: number) => (
                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} key={index}>
                      <TableCell>
                        {row.isNew ? (
                          <Autocomplete
                            disabled={!updateSQFLPermission}
                            id="tags-standard"
                            options={usersList}
                            getOptionLabel={(option: any) => option}
                            renderInput={params => (
                              <TextField {...params} variant="standard" label="User" placeholder="User" />
                            )}
                            onChange={(e, values) => handleChangeSingle(e, values, row.id)}
                          />
                        ) : (
                          <>{row.approver_function}</>
                        )}
                      </TableCell>
                      <TableCell>
                        {row.isNew || row.needtoupdate ? (
                          <TextField
                            id="salutationField"
                            placeholder="Comment"
                            variant="standard"
                            className="salutationField"
                            value={row.approver_comment}
                            onChange={(e: any) => handleComment(e, row.id)}
                            disabled={
                              row.isNew ||
                              row.approved_by !== null ||
                              !(approveSQFLPermission && row.approver_function === user)
                            }
                            style={{ marginTop: '11px' }}
                          />
                        ) : (
                          <>{row.approver_comment}</>
                        )}
                      </TableCell>
                      <TableCell>
                        {row.isNew || row.approved_by === null ? (
                          <Button
                            size="small"
                            variant="contained"
                            onClick={() => handleSignApproval(row)}
                            disabled={row.isNew || !(approveSQFLPermission && row.approver_function === user)}
                          >
                            Sign
                          </Button>
                        ) : (
                          <span className="signedInfo">
                            Signed by <strong>{row.approved_by}</strong>
                            <br />
                            on <span color="text.secondary">
                              {getPreferredDateTimeInLocal(row.approved_datetime)}
                            </span>{' '}
                            <br />
                            <span className="signReasonrow">
                              <span color="text.secondary">Reason:</span> &ldquo;
                              {row.reason}
                              &rdquo;
                            </span>
                            <br />
                            <i>({row.approver_email})</i>
                            <br />
                            <span color="text.secondary">({row.approver_role})</span>
                          </span>
                        )}
                      </TableCell>
                      <TableCell>
                        {row?.approved_datetime ? getPreferredDateTimeInLocal(row?.approved_datetime) : ''}
                      </TableCell>
                      <TableCell>
                        {row.isNew ? (
                          <Tooltip title="Remove" placement="top">
                            <IconButton onClick={() => handleClose(row)}>
                              <CloseIcon />
                            </IconButton>
                          </Tooltip>
                        ) : (
                          <></>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </Box>
      <Button
        sx={{ mt: 1.5 }}
        startIcon={<AddIcon />}
        onClick={() => handleAdd()}
        disabled={!updateSQFLPermission || addDisable || isVersion}
      >
        Add
      </Button>

      <PopupComponent open={openImport} sx={{ '@media (max-width:1367px)': { marginTop: '-136px' } }}>
        <DialogTitle id="alert-dialog-title">{'Import'}</DialogTitle>
        <DialogContent sx={{ minWidth: '600px' }}>
          <Grid container spacing={2} className="event-form">
            <Grid item xs={12}>
              <FormControl fullWidth sx={{ mt: 1 }}>
                <InputLabel
                  required
                  id="selectVisit"
                  sx={{
                    '&[data-shrink="false"]': { transform: 'translate(0, 16px) scale(1)' },
                    '&[data-shrink="true"]': { transform: 'translate(0, -9px) scale(0.75)' }
                  }}
                >
                  Visit
                </InputLabel>
                <Select
                  required
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Visit"
                  defaultValue={'10'}
                  onChange={handleChange}
                >
                  <MenuItem value={'10'}>{selectedRow?.visit_name}</MenuItem>
                </Select>
              </FormControl>

              <Grid />
            </Grid>
            <Grid item xs={6}>
              <LocalizationProvider
                dateAdapter={AdapterDayjs}
                variant="standard"
                className="custom-datePicker"
                fullWidth
              >
                <FormControl fullWidth>
                  <DesktopDatePicker
                    inputFormat={dateFormat}
                    label="Start Date"
                    value={preferedFormatForDatePicker(importFields?.sq_visit_start_date)}
                    maxDate={preferedFormatForDatePicker(importFields?.sq_visit_end_date)}
                    onChange={(newValue: any) => {
                      if (newValue != null) {
                        setImportFields({
                          ...importFields,
                          sq_visit_start_date: getServerDateOrInvalid(newValue)
                        });
                        setImportFieldError({
                          ...importFieldError,
                          sq_visit_start_date: false
                        });
                      } else {
                        setImportFieldError({
                          ...importFieldError,
                          sq_visit_start_date: true
                        });
                      }
                    }}
                    renderInput={(params: any) => (
                      <TextField
                        {...params}
                        error={importFieldError?.sq_visit_start_date}
                        helperText={importFieldError?.sq_visit_start_date ? 'Required' : ''}
                        required
                        variant="standard"
                        InputLabelProps={{ shrink: true }}
                      />
                    )}
                  />
                </FormControl>
              </LocalizationProvider>
            </Grid>
            <Grid item xs={6}>
              <LocalizationProvider
                dateAdapter={AdapterDayjs}
                variant="standard"
                className="custom-datePicker"
                fullWidth
              >
                <FormControl fullWidth>
                  <DesktopDatePicker
                    //disableFuture
                    inputFormat={dateFormat}
                    label="End Date"
                    value={preferedFormatForDatePicker(importFields?.sq_visit_end_date)}
                    minDate={preferedFormatForDatePicker(importFields?.sq_visit_start_date)}
                    onChange={(newValue: any) => {
                      if (newValue != null) {
                        setImportFields({
                          ...importFields,
                          sq_visit_end_date: getServerDateOrInvalid(newValue)
                        });
                        setImportFieldError({
                          ...importFieldError,
                          sq_visit_end_date: false
                        });
                      } else {
                        setImportFieldError({
                          ...importFieldError,
                          sq_visit_end_date: true
                        });
                      }
                    }}
                    renderInput={(params: any) => (
                      <TextField
                        {...params}
                        error={importFieldError?.sq_visit_end_date}
                        helperText={importFieldError?.sq_visit_end_date ? 'Required' : ''}
                        required
                        variant="standard"
                        InputLabelProps={{ shrink: true }}
                      />
                    )}
                  />
                </FormControl>
              </LocalizationProvider>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseImport} className="grey-btn">
            Cancel
          </Button>
          <Button onClick={handleImportSubmit} autoFocus>
            Submit
          </Button>
        </DialogActions>
      </PopupComponent>

      <PopupComponent
        open={openConfirmExit}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="confirm-modal"
        child
      >
        <DialogTitle id="alert-dialog-title">{'Confirm Exit'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{unSavedWarning}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenConfirmExit(false);
            }}
            className="grey-btn"
          >
            Close
          </Button>
          <Button
            onClick={() => {
              setSqFollowupLetterOpen(true);
              setStudyLogOpen(false);
              setIsChange(false);
              setNTFGrid(true);
              setOpenSQFollowLetter(false);
            }}
          >
            Ok
          </Button>
        </DialogActions>
      </PopupComponent>
      {openEmailPopoup && (
        <EmailActivity
          openEmailPopoup={openEmailPopoup}
          setOpenEmailPopoup={setOpenEmailPopoup}
          documentDetails={documentOnTmfDocumentIdData}
          permission={'UPDATE_SITEQUALIFI_FOLLOWUPLETTER'}
        />
      )}
      <PopupComponent aria-labelledby="customized-dialog-title" open={openVersionPopup} maxWidth="lg">
        <DialogTitle>Please Confirm</DialogTitle>
        <DialogContent>
          <Typography variant="body1">Are you sure you want to create a new version?</Typography>
        </DialogContent>
        <DialogActions>
          <Button className="grey-btn" onClick={() => setOpenVersionPopup(!openVersionPopup)}>
            Cancel
          </Button>
          <Button onClick={handleCreateNewversion}>Create</Button>
        </DialogActions>
      </PopupComponent>
      {openSignConsent && (
        <ESignConsentReAuth
          openSignConsent={openSignConsent}
          setOpenSignConsent={setOpenSignConsent}
          handleConfirmSign={handleSQApproverSign}
        />
      )}
    </>
  );
};

export default SiteQualitficationFollowupLetter;
